import { render, staticRenderFns } from "./NotificationContainer.vue?vue&type=template&id=2e863d52&"
import script from "./NotificationContainer.vue?vue&type=script&lang=ts&"
export * from "./NotificationContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports